import { createContext, useContext } from 'react';

import { noop } from '@utils/browser';

import { AiChatProps, ChatMessage } from './types';

type AiAssistInputContextProps = {
  sendChatMessage(props: AiChatProps): Promise<ChatMessage>;
};

const AiInputAssistContext = createContext<AiAssistInputContextProps>({
  sendChatMessage: noop as any,
});

export const AiInputAssistProvider: React.FC<AiAssistInputContextProps> = ({
  children,
  ...rest
}) => {
  return <AiInputAssistContext.Provider value={rest} children={children} />;
};

export const useAiInputAssistSendMessage = () => {
  const { sendChatMessage } = useContext(AiInputAssistContext);
  return sendChatMessage;
};
